import { render } from "./SubmenuLink.vue?vue&type=template&id=afc01128&scoped=true&bindings={\"link\":\"props\",\"idx\":\"props\",\"cssClass\":\"options\",\"handleClick\":\"options\"}"
import script from "./SubmenuLink.vue?vue&type=script&lang=js"
export * from "./SubmenuLink.vue?vue&type=script&lang=js"

import "./SubmenuLink.vue?vue&type=style&index=0&lang=css"
import "./SubmenuLink.vue?vue&type=style&index=1&id=afc01128&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-afc01128"

export default script